import React, { useRef } from 'react';

import { useIntersection } from './useIntersection';

type Props = { height: number, enabled: boolean, children: React.ReactNode };

export const VirtualItem = ({ height, enabled, children }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const inViewport = useIntersection(enabled, ref, '100px', true);

  if (inViewport || !enabled) {
    return children;
  }

  return <div ref={ref} style={{ height }} />;
};
